import React, { useState } from 'react';
import { fmtPesos } from '../engine/perfil';

// S13 · Plan cerrado dentro de los límites: cierra sin humano. S8 · «Pagar» simula la API de la aseguradora.
export const CierrePago = ({ plan, onPagado, onAsesor, onCambiar, locked }) => {
  const [forma, setForma] = useState('Mensual con débito automático');
  const [fase, setFase] = useState('elegir'); // elegir · conectando · listo
  const [ref] = useState(() => `MBM-${Math.floor(100000 + Math.random() * 900000)}`);
  const pagar = () => {
    setFase('conectando');
    setTimeout(() => { setFase('listo'); onPagado(ref, forma); }, 1800);
  };
  return (
    <section className="pago" data-testid="cierre-pago">
      <div className="pago-res">
        <span className="pago-k">Resumen</span>
        <b>{plan.producto}</b>
        <span>{plan.label}{plan.va ? ` · valor asegurado ${fmtPesos(plan.va)}` : ''}</span>
        <span className="pago-prima">{`${fmtPesos(plan.prima)} al mes`}</span>
      </div>
      {fase === 'elegir' ? (
        <>
          <span className="pago-k">¿Cómo prefiere pagar?</span>
          <div className="pf-opts">
            {['Mensual con débito automático', 'Mensual con tarjeta de crédito'].map((f) => (
              <button key={f} type="button" disabled={locked} className={forma === f ? 'on' : ''} onClick={() => setForma(f)}>{f}</button>
            ))}
          </div>
          <button type="button" className="pago-btn" disabled={locked} onClick={pagar} data-testid="btn-pagar">Pagar con la aseguradora</button>
          <button type="button" className="btn-atras" disabled={locked} onClick={onCambiar} data-testid="btn-cambiar-plan">← Cambiar de plan o de valor</button>
          <button type="button" className="cmv-asesor" disabled={locked} onClick={onAsesor}>Prefiero que un asesor me llame antes</button>
        </>
      ) : null}
      {fase === 'conectando' ? <span className="pago-estado" data-testid="pago-conectando">Conectando con la pasarela de la aseguradora…</span> : null}
      {fase === 'listo' ? <span className="pago-estado ok" data-testid="pago-listo">{`Solicitud ${ref} recibida.`}</span> : null}
      <p className="cmv-rotulo">Demo: en producción este botón abre la pasarela de pagos de la aseguradora por API.</p>
    </section>
  );
};
